module.exports = __webpack_public_path__ + "img/glass.e96fd59.svg";